import axios from "axios";
export default class ApiLandingPages {
    static async GetLandingPagesList(session_uuid) {
        try {
            const result = await axios.get("/api/web-api/public/get-landing-pages", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async GetLandingPageByUUID(session_uuid, uuid) {
        try {
            const result = await axios.get("/api/web-api/public/get-landing-page/" + uuid, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async DeleteLandingPage(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/delete-landing-page", {
                uuid: uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async CreateLandingPage(session_uuid, data) {
        try {
            const result = await axios.post("/api/admin/create-landing-page", data, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async UpdateLandingPage(session_uuid, data) {
        try {
            const result = await axios.post("/api/admin/update-landing-page", data, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
}
